const initialState = {
  selectedCity: "",
  operatorConfig: {},
  operatorConfigData: {},
};
export default initialState;
